export default __webpack_public_path__ + "static/template-home-about-hero-background-5fdb3edddc40e94e65608048ddf7035e.jpg";